import axios from "axios";

export const DEVICE_LIST_LOADING = "DEVICE_LIST_LOADING";
export const DEVICE_LIST_SUCCESS = "DEVICE_LIST_SUCCESS";
export const DEVICE_LIST_ERROR = "DEVICE_LIST_ERROR";

export const DEVICE_DELETE_LOADING = "DEVICE_DELETE_LOADING";
export const DEVICE_DELETE_SUCCESS = "DEVICE_DELETE_SUCCESS";
export const DEVICE_DELETE_ERROR = "DEVICE_DELETE_ERROR";

export const FETCH_DEVICE_FILTER_VALUES_LOADING = "FETCH_DEVICE_FILTER_VALUES_LOADING";
export const FETCH_DEVICE_FILTER_VALUES_SUCCESS = "FETCH_DEVICE_FILTER_VALUES_SUCCESS";
export const FETCH_DEVICE_FILTER_VALUES_ERROR = "FETCH_DEVICE_FILTER_VALUES_ERROR";

export const FETCH_DEVICE_BY_ID_LOADING = "FETCH_DEVICE_BY_ID_LOADING";
export const FETCH_DEVICE_BY_ID_SUCCESS = "FETCH_DEVICE_BY_ID_SUCCESS";
export const FETCH_DEVICE_BY_ID_ERROR = "FETCH_DEVICE_BY_ID_ERROR";

export const DOWNLOAD_LIST_LOADING = "DOWNLOAD_LIST_LOADING";
export const DOWNLOAD_LIST_SUCCESS = "DOWNLOAD_LIST_SUCCESS";
export const DOWNLOAD_LIST_ERROR = "DOWNLOAD_LIST_ERROR";


export const RESTE_DEVICE_DETAILS = "RESTE_DEVICE_DETAILS";

export const FETCH_CUSTOMER_DROPDOWN_LOADING = "FETCH_CUSTOMER_DROPDOWN_LOADING";
export const FETCH_CUSTOMER_DROPDOWN_SUCCESS = "FETCH_CUSTOMER_DROPDOWN_SUCCESS";
export const FETCH_CUSTOMER_DROPDOWN_ERROR   = "FETCH_CUSTOMER_DROPDOWN_ERROR";

export const FETCH_BUILDING_DROPDOWN_LOADING = "FETCH_BUILDING_DROPDOWN_LOADING";
export const FETCH_BUILDING_DROPDOWN_SUCCESS = "FETCH_BUILDING_DROPDOWN_SUCCESS";
export const FETCH_BUILDING_DROPDOWN_ERROR   = "FETCH_BUILDING_DROPDOWN_ERROR";

export const FETCH_FLOOR_DROPDOWN_LOADING = "FETCH_FLOOR_DROPDOWN_LOADING";
export const FETCH_FLOOR_DROPDOWN_SUCCESS = "FETCH_FLOOR_DROPDOWN_SUCCESS";
export const FETCH_FLOOR_DROPDOWN_ERROR   = "FETCH_FLOOR_DROPDOWN_ERROR";

export const FETCH_DEVICE_TYPE_DROPDOWN_LOADING = "FETCH_DEVICE_TYPE_DROPDOWN_LOADING";
export const FETCH_DEVICE_TYPE_DROPDOWN_SUCCESS = "FETCH_DEVICE_TYPE_DROPDOWN_SUCCESS";
export const FETCH_DEVICE_TYPE_DROPDOWN_ERROR   = "FETCH_DEVICE_TYPE_DROPDOWN_ERROR";


export const fetchCustomerDropdown = () => async (dispatch) => {
  dispatch({ type: FETCH_CUSTOMER_DROPDOWN_LOADING });
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/customer/dropdown`,
      {
        headers: {
          Accept: "application/hal+json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: FETCH_CUSTOMER_DROPDOWN_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: FETCH_CUSTOMER_DROPDOWN_ERROR,
      payload: error.response?.data || error.message,
    });
  }
};

export const fetchBuildingDropdown = (customerIds = []) => async (dispatch) => {
  dispatch({ type: FETCH_BUILDING_DROPDOWN_LOADING });
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_ALL}/dropdown`,
      customerIds, // example: ["67","52"]
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/hal+json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: FETCH_BUILDING_DROPDOWN_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: FETCH_BUILDING_DROPDOWN_ERROR,
      payload: error.response?.data || error.message,
    });
  }
};

export const fetchFloorDropdown = (buildingIds = []) => async (dispatch) => {
  dispatch({ type: FETCH_FLOOR_DROPDOWN_LOADING });
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_DEVICE_API_URL}/v1/floor/dropdown`,
      buildingIds,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/hal+json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: FETCH_FLOOR_DROPDOWN_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: FETCH_FLOOR_DROPDOWN_ERROR,
      payload: error.response?.data || error.message,
    });
  }
};

export const fetchDeviceTypeDropdown = () => async (dispatch) => {
  dispatch({ type: FETCH_DEVICE_TYPE_DROPDOWN_LOADING });
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/deviceType/dropdown`,
      {}, // body empty
      {
        headers: {
          Accept: "application/hal+json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: FETCH_DEVICE_TYPE_DROPDOWN_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_DEVICE_TYPE_DROPDOWN_ERROR,
      payload: error.response?.data || error.message,
    });
  }
};

export const fetAllDevices = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: DEVICE_LIST_LOADING });
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/v1/device/all`;
    const requestBody = {
      customerNames: filters.customerNames ?? [],
      buildingIds: filters.buildingId ?? [],
      floorNames: filters.floorName.length > 0 ? filters.floorName : [],
      sortBy: filters.sortBy || "createdAt",
      sortDirection: filters.sortDirection || "DESC",
      typeIds: filters.typeIds,
      page: filters.page ?? 0,
      size: filters.size ?? 5,
    };

    const response = await axios.post(url, requestBody, {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      dispatch({ type: DEVICE_LIST_SUCCESS, payload: response.data });
    }
  } catch (error) {
    dispatch({
      type: DEVICE_LIST_ERROR,
      payload: error.response?.data || error.message,
    });
  }
};

export const deleteDeviceComponents = (id) => async (dispatch) => {
    dispatch({type: DEVICE_DELETE_LOADING});
    let token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/v1/device/${id}`;
    try {
      const response = await axios.delete(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        dispatch({type: DEVICE_DELETE_SUCCESS});
        dispatch(fetAllDevices());
      }
    } catch (error) {
        dispatch({type: DEVICE_DELETE_ERROR, payload: error});
    }
};

export const fetchDeviceById = (deviceID) => async (dispatch) => {
  dispatch({type: FETCH_DEVICE_BY_ID_LOADING});
    let token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/v1/device/${deviceID}`;
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status == 200) {
        dispatch({type: FETCH_DEVICE_BY_ID_SUCCESS, payload: response.data});
      }
    } catch (error) {
        dispatch({type: FETCH_DEVICE_BY_ID_ERROR, payload: error});
    }
}

// export const downloadActions = (action) => async (dispatch) => {
//   dispatch({ type: DOWNLOAD_LIST_LOADING });

//   let token = JSON.parse(localStorage.getItem("token"));
//   let url = "";


//   if (action === "template") {
//     url = `${process.env.REACT_APP_DEVICE_API_URL}/api/v1/data/data/excel?template=true`;
//   } else {
//     url = `${process.env.REACT_APP_DEVICE_API_URL}/api/v1/data/data/excel?template=false`;
//   }

//   try {
//     const response = await axios.get(url, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//       responseType: "blob", // 👈 important: get binary file
//     });

//     if (response.status === 200) {
//       // create blob url
//       const blob = new Blob([response.data], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });

//       const downloadUrl = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;

//       // choose filename
//       const fileName = action === "template" ? "device_template.xlsx" : "device_data.xlsx";
//       link.setAttribute("download", fileName);

//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);

//       dispatch({ type: DOWNLOAD_LIST_SUCCESS });
//     }
//   } catch (error) {
//     dispatch({ type: DOWNLOAD_LIST_ERROR, payload: error });
//   }
// };

export const downloadActions = (action, filters) => async (dispatch) => {
  dispatch({ type: DOWNLOAD_LIST_LOADING });

  let token = JSON.parse(localStorage.getItem("token"));
  let url = "";
  if (action === "template") {
    url = `${process.env.REACT_APP_DEVICE_API_URL}/api/v1/data/data/excel?template=true`;
  } else {
    url = `${process.env.REACT_APP_DEVICE_API_URL}/api/v1/data/excel/exportFiltered`;
  }

  try {
    let response = "";
    if (action === "template") {
      response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });
    } else  {
      const requestBody = {
        customerNames: filters.customerNames || "",
        buildingId: filters.buildingId || "",
        floorNames: filters.floorName.length > 0 ? filters.floorName : [],
        sortBy: filters.sortBy || "createdAt",
        sortDirection: filters.sortDirection || "DESC",
        typeIds: filters.typeIds,
      };
      response = await axios.post(url, requestBody, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });
    }

    if (response.status === 200) {
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;

      const fileName = action === "template" ? "device_template.xlsx" : "device_data.xlsx";
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      dispatch({ type: DOWNLOAD_LIST_SUCCESS });
    }
  } catch (error) {
    dispatch({ type: DOWNLOAD_LIST_ERROR, payload: error });
  }
};